'use strict';
import zoom from './zoom';
import aos from '../anims/appear-on-scroll';

const tint = {
    social : new Array(),
	init: function(){
        if ( document.querySelector('.zoom') ) {
		    tint.loadJson();
        }
    },

    // chargement du json depuis l'api tint
    loadJson: function() {
        let request = new XMLHttpRequest();

        try {
            request.open("GET", apiDataCentre.getSocialPosts);
            request.onreadystatechange = function () {
                if (request.readyState == 4 && request.status == 200) {
                    let data = JSON.parse(request.responseText);
                    data.forEach(element => {
                        tint.social.push(element);
                    });
                    if ( document.querySelector('.zoom') )
                        tint.layout();
                }
            };
            request.send();
        }
        catch(err) {
            // console.log(err)
        }
    },

    // création des posts depuis l'api
    layout: function() {
        let itemList = document.querySelector('.zoom_list');
        let i = 0;
        // Creation markup
        for (let post of tint.social) {
            i++;
            if (post.network === 'instagram_business' || post.network === 'instagram') {
                let el = document.createElement('a');
                el.classList.add('zoom_item');
                el.setAttribute('target', '_blank');
                el.setAttribute('href', post.url);
                el.setAttribute('data-in-view', '');
                el.innerHTML = '<div class="zoom_appearAnim" data-in-view><img src="' + post.media['default'] + '" alt=""><div class="zoom_content"><div class="zoom_content-text"><p>' + post.text + '</p></div><div class="zoom_content-icon icon-instagram"></div></div></div>';
                itemList.appendChild(el);
            }
            else if (post.network === 'facebook') {
                let el = document.createElement('a');
                el.classList.add('zoom_item');
                el.setAttribute('target', '_blank');
                el.setAttribute('href', post.url);
                el.setAttribute('data-in-view', '');
                el.innerHTML = '<div class="zoom_appearAnim" data-in-view><img src="' + post.media['default'] + '" alt=""><div class="zoom_content"><div class="zoom_content-text"><p class="date">' + post.date + '</p><p>' + post.text + '</p></div><div class="zoom_content-icon icon-facebook"></div></div></div>';
                itemList.appendChild(el);
            }
            if (i === 14)
                break;
        }

        // initialiation des tuiles avec isotope
        zoom.init();
        aos.init();
    }
};

export default tint;


// WEBPACK FOOTER //
// ./src/scripts/components/tint.js